import React from "react";
import { Modal } from "react-bootstrap";
import { useQRModal } from "../../context/QRModalContext";
import "../../styles/QRCodeModal.css";

/**
 * Can be used two ways:
 * 1. As root modal (in App.js) — no props, reads from QRModalContext
 * 2. With explicit props — <QRCodeModal show={bool} onHide={fn} />
 */
const QRCodeModal = ({ show: showProp, onHide: onHideProp } = {}) => {
  const context = useQRModal();
  const show = showProp !== undefined ? showProp : context?.show ?? false;
  const onHide = onHideProp !== undefined ? onHideProp : context?.closeQRModal ?? (() => {});

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="sm"
      contentClassName="qr-modal-content"
    >
      <Modal.Body className="qr-modal-body">
        <button className="qr-modal-close" onClick={onHide} aria-label="Close">
          &times;
        </button>

        <p className="qr-modal-eyebrow">GET THE APP</p>
        <h2 className="qr-modal-title">Scan to Download</h2>
        <p className="qr-modal-subtitle">
          Scan the QR code with your phone camera to download Sârv from the App Store or Google Play.
        </p>

        <div className="qr-modal-image-wrapper">
          <img
            src="/my-applink-qrcode.png"
            alt="Scan QR code to download the Sarv app"
            className="qr-modal-image"
          />
        </div>

        <p className="qr-modal-hint">Get started for free</p>
      </Modal.Body>
    </Modal>
  );
};

export default QRCodeModal;
